import { chakra } from '@chakra-ui/react';

export const SpeakerCardContainer = chakra('div', {
  baseStyle: {
    cursor: 'pointer',
    display: 'inline-block',
    bg: 'transparent',
    _hover: { textDecor: 'none' },
  },
  label: 'SpeakerCard',
});
